// Usage: https://flatpickr.js.org/
import flatpickr from "flatpickr";
import { MandarinTraditional } from "flatpickr/dist/l10n/zh-tw.js";
import rangePlugin from "flatpickr/dist/plugins/rangePlugin";

flatpickr.localize(MandarinTraditional)
window.flatpickr = flatpickr; 
window.fpRangePlugin = rangePlugin
